var map = {
	"./de-de/countries.json": [
		835,
		7
	],
	"./es-es/countries.json": [
		836,
		6
	],
	"./fr-ca/countries.json": [
		837,
		5
	],
	"./fr-fr/countries.json": [
		838,
		4
	],
	"./it-it/countries.json": [
		839,
		3
	],
	"./nb-no/countries.json": [
		840,
		2
	],
	"./nl-nl/countries.json": [
		841,
		1
	],
	"./sv-se/countries.json": [
		842,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2274;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./locale lazy ^\.\/.*\/countries\.json$
// module id = 2274
// module chunks = 72